@@ -0,0 +1,217 @@
<template>
  <div>
    <material-card
      :title="$t('views.guides.dental_fee_guides')"
      icon="description"
      style="margin-top: 20px"
      v-if="options"
    >
      <template v-slot:actions>
        <div style="margin-right: 20px; margin-top: 10px">
          <v-btn @click="dialogs.importGuide = true" color="primary">
            {{ $t("components.guides.import_guide_dialog.import_guide_{0}", [guideTitle()]) }}
          </v-btn>
        </div>
      </template>
      <v-card-text>
        <search-form coverage="Dental" @update="loadData"/>
      </v-card-text>
      <!-- <v-card-actions>
      <v-btn @click="apply" :disabled="disabled" color="primary">
        {{ $t("globals.apply") }}
      </v-btn>
    </v-card-actions> -->
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        :showSelect="false"
        @error="error = $event"
        :exporters="$exporters"
        :noSearch="true"
        :noFilters="true"
      ></pbas-data-table>
      <error-handler :error="error"></error-handler>
      <import-guide-dialog
        @close="dialogs.importGuide = false"
        @success="
          dialogs.importGuide = false;
          message = $event;
          snackbar = true;
          loadProvinces();
        "
        :model="dialogs.importGuide"
        coverage="Dental"
      />
      <v-snackbar v-model="snackbar" color="success" :timeout="2500">
        {{ message }}
        <v-btn dark text @click="snackbar = false">
          {{ $t("globals.close") }}
        </v-btn>
      </v-snackbar>
    </material-card>
    <v-row justify="center" v-else>
      <v-progress-circular
        :size="70"
        :width="7"
        color="purple"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import getFeesHeaders from "@/headers/Fees";
import ErrorHandler from "@/components/ErrorHandler";
import ImportGuideDialog from "./ImportGuideDialog";
import SearchForm from "./SearchForm.vue";
export default {
  components: {
    ErrorHandler,
    ImportGuideDialog,
    SearchForm
  },
  data() {
    return {
      error: null,
      provider: undefined,
      dialogs: {
        importGuide: false,
      },
      snackbar: false,
      message: "",
    };
  },
  computed: {
    ...mapGetters("common", ["settings"]),
    ...mapGetters("plansMembers", ["options"]),
  },
  
  methods: {
    guideTitle(){
      return this.$t("views.guides.dental_fee_guides");
    },
    loadData(filter) {
      if (filter) {
        if (this.provider === undefined) {
          this.provider = new ODataProvider(
            this.$axiosHttp,
            this.settings.APIURL + "fees",
            getFeesHeaders(this.options.Models.Province)
          );
          this.provider.filter = filter;
        } else {
          this.provider.filter = filter;
          this.$refs.table.getDataAsync();
        }
      } else {
        this.provider = undefined;
      }
    },
  },
};
</script>
